// Per-unit merge pages (/editmerges/floorplans, /editmerges/warranties) share one editor.
// Each entry says which unit field holds the PDF and which holds the linked merge template.
export interface IUnitMergeConfig {
  urlField: 'getUrl' | 'getWarrantyUrl';
  templateField: 'floorPlan' | 'warrantySheet';
  type: string;
  label: string;
}

export const unitMergeConfigs: { [mergeid: string]: IUnitMergeConfig } = {
  floorplans: { urlField: 'getUrl', templateField: 'floorPlan', type: 'Floorplan', label: 'Floorplan' },
  warranties: { urlField: 'getWarrantyUrl', templateField: 'warrantySheet', type: 'Warranty', label: 'Warranty' },
};

export const getUnitMergeConfig = (mergeid?: string): IUnitMergeConfig | null => (mergeid && unitMergeConfigs[mergeid]) || null;
